import { createAction, props } from "@ngrx/store";
import { StorageRack } from 'app/modules/masters/storage-rack/model/storage-rack.model';

// Load All
export const loadStorageRacks = createAction("[StorageRack] Load StorageRacks");
export const loadStorageRacksSuccess = createAction(
  "[StorageRack] Load StorageRacks Success",
  props<{ storageRacks: StorageRack[] }>()
);
export const loadStorageRacksFailure = createAction(
  "[StorageRack] Load StorageRacks Failure",
  props<{ error: any }>()
);

// Load One
export const loadStorageRack = createAction(
  "[StorageRack] Load StorageRack",
  props<{ id: string }>()
);
export const loadStorageRackSuccess = createAction(
  "[StorageRack] Load StorageRack Success",
  props<{ storageRack: StorageRack }>()
);

// Create
export const createStorageRack = createAction(
  "[StorageRack] Create StorageRack",
  props<{ storageRack: StorageRack }>()
);
export const createStorageRackSuccess = createAction(
  "[StorageRack] Create StorageRack Success",
  props<{ storageRack: StorageRack }>()
);

// Update
export const updateStorageRack = createAction(
  "[StorageRack] Update StorageRack",
  props<{ id: string; storageRack: StorageRack }>()
);
export const updateStorageRackSuccess = createAction(
  "[StorageRack] Update StorageRack Success",
  props<{ storageRack: StorageRack }>()
);

// Delete
export const deleteStorageRack = createAction(
  "[StorageRack] Delete StorageRack",
  props<{ id: string }>()
);
export const deleteStorageRackSuccess = createAction(
  "[StorageRack] Delete StorageRack Success",
  props<{ id: string }>()
);

// 🔍 Search Storage Racks
export const searchStorageRacks = createAction(
  "[StorageRack] Search Storage Racks",
  props<{ query: { search?: string; limit?: number } }>()
);

export const searchStorageRacksSuccess = createAction(
  "[StorageRack] Search Storage Racks Success",
  props<{ searchResults: StorageRack[] }>()
);

export const searchStorageRacksFailure = createAction(
  "[StorageRack] Search Storage Racks Failure",
  props<{ error: any }>()
);
